import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/15290afefd9dc18808da5e9cfafe4a44.jpg"
          alt="건강한 자세"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="w-full px-8 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/c8b71189-98c0-495d-9ead-2dc02fa0e5ca.png" 
              alt="로고" 
              className="h-12 w-auto"
            />
          </div>
          <div className="flex items-center gap-12">
            <button onClick={() => scrollToSection('features')} className={`text-base font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>기능</button>
            <button onClick={() => scrollToSection('about')} className={`text-base font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>소개</button>
            <button onClick={() => scrollToSection('quiz')} className={`text-base font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>진단</button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-base font-medium transition-colors cursor-pointer ${scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>후기</button>
          </div>
          <button onClick={() => scrollToSection('contact')} className={`px-6 py-2.5 rounded-full border-2 font-medium transition-all cursor-pointer whitespace-nowrap ${scrolled ? 'border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white' : 'border-white text-white hover:bg-white hover:text-teal-600'}`}>
            문의하기
          </button>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative h-full flex flex-col justify-between px-16 py-32">
        {/* Main Title */}
        <div className="flex-1 flex items-center">
          <div className="w-full max-w-2xl">
            <h1 className="text-7xl font-bold text-white leading-tight mb-8">
              건강한 발,<br />
              바른 자세로<br />
              시작하는 일상
            </h1>
            <button onClick={() => scrollToSection('quiz')} className="px-8 py-4 bg-teal-500 text-white text-lg font-semibold rounded-full hover:bg-teal-600 transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2">
              맞춤 인솔 찾기 <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        {/* Bottom Slogan */}
        <div className="w-full">
          <h2 className="text-8xl font-bold text-white opacity-90 tracking-tight">
            HEALTHY POSTURE STARTS HERE
          </h2>
        </div>
      </div>
    </section>
  );
}
